import {OnSetData} from './part-interface';
import {Component} from '@angular/core';

@Component({
  selector: 'app-abstract-page-component',
  template: ``,
  styleUrls: []
})
export class AbstractPartComponent implements OnSetData {
  public pageData: any;
  constructor() {
  }
  setData(val: any) {
    this.pageData = val;
  }
}
